import { ChatHistoryItem, ChatMonitorRow } from "../../common/requests/chats/endpoints";
import { formatDate, formatTimeString } from "../../common/constant/dates";

export function formatDateTime(value: string | Date | null | undefined) {
  if (!value) return "–";
  return `${formatDate(value)} ${formatTimeString(value, true)}`;
}

export function toMillis(value: string | Date | null | undefined) {
  if (!value) return 0;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
}

export function truncateMiddle(value: string | null | undefined, head = 6, tail = 4) {
  if (!value) return "–";
  if (value.length <= head + tail + 1) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}

/** Display name for a buyer or seller in a chat row. */
export const buyerName = (row: ChatMonitorRow) => row.buyer_username || row.buyer_email || row.buyer_id;
export const sellerName = (row: ChatMonitorRow) => row.seller_username || row.seller_email || row.seller_id;

/** Who sent a message: the buyer's or seller's name when the sender id
 * matches the chat's buyer or seller, otherwise the raw id. */
export function resolveSenderName(item: ChatHistoryItem, row: ChatMonitorRow | null | undefined) {
  const senderId = (item.sender || "").trim();
  if (!senderId) return "Unknown sender";
  if (!row) return senderId;
  if (senderId === (row.buyer_id || "").trim()) return row.buyer_username || row.buyer_email || "Buyer";
  if (senderId === (row.seller_id || "").trim()) return row.seller_username || row.seller_email || "Seller";
  return senderId;
}

/** Which side of the conversation a message is on (for bubble alignment). */
export function senderSide(item: ChatHistoryItem, row: ChatMonitorRow | null | undefined): "buyer" | "seller" | "other" {
  const senderId = (item.sender || "").trim();
  if (row && senderId && senderId === (row.buyer_id || "").trim()) return "buyer";
  if (row && senderId && senderId === (row.seller_id || "").trim()) return "seller";
  return "other";
}

/** Oldest first, like a chat app. */
export const sortMessages = (messages: ChatHistoryItem[]) =>
  [...messages].sort((left, right) => toMillis(left.timestamp) - toMillis(right.timestamp));

/** The row a `?chat=<id>` param points at (ids compared trimmed). */
export const findChat = (rows: ChatMonitorRow[], id: string | null) => {
  const want = (id || "").trim();
  return want ? rows.find((r) => (r.chat_id || "").trim() === want) ?? null : null;
};
